// src/pages/EducationPage.js
import React from "react";
import { Link } from "react-router-dom";
import { educationData } from "../data/data";
import background from "../assets/background.jpg";

const EducationPage = () => {
  return (
    <div
      className="relative w-full min-h-screen bg-cover bg-center flex flex-col items-center"
      style={{
        backgroundImage: `url(${background})`,
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <header className="relative pt-20 flex flex-col items-center z-10 px-4">
        <h1 className="text-3xl font-bold text-white drop-shadow-md">
          Education
        </h1>
      </header>

      <main className="relative z-10 w-full max-w-2xl px-4 mt-12 mb-12 flex flex-col items-center space-y-8">
        {educationData.map((edu, i) => (
          <div key={i} className="bg-gray-900 p-4 rounded-lg shadow w-full">
            <div className="flex items-center space-x-4">
              {edu.icon}
              <div>
                <h3 className="text-lg font-bold text-white">{edu.degree}</h3>
                <p className="text-gray-300">{edu.institution}</p>
                <p className="text-gray-400 text-sm">{edu.date}</p>
              </div>
            </div>
            <div className="mt-2 text-gray-200 space-y-2">
              {edu.details.map((line, idx) => (
                <p key={idx}>{line}</p>
              ))}
            </div>
          </div>
        ))}

        <Link
          to="/"
          className="py-2 px-4 rounded-lg shadow font-medium text-white bg-blue-600 hover:bg-blue-700 transition transform hover:scale-105"
        >
          Back Home
        </Link>
      </main>
    </div>
  );
};

export default EducationPage;
